module.exports = __webpack_public_path__ + "static/media/klima-14.4d36009c.jpg";